import { render, staticRenderFns } from "./shopForeignList.vue?vue&type=template&id=6130b533&scoped=true"
import script from "./shopForeignList.vue?vue&type=script&lang=js"
export * from "./shopForeignList.vue?vue&type=script&lang=js"
import style0 from "./shopForeignList.vue?vue&type=style&index=0&id=6130b533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130b533",
  null
  
)

export default component.exports